import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useResizeObserver } from '../../hooks';

type Props = {
  children: React.ReactNode;
  animate?: boolean;
  onSizeChange: () => void;
};

const PopoverRoot = ({ children, onSizeChange, animate = false }: Props) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const { width, height } = useResizeObserver(container);

  useEffect(() => {
    onSizeChange();
  }, [width, height, onSizeChange]);

  return (
    <div className={classNames('ui-popover__root', { 'ui-popover__root--animate': animate })} ref={setContainer}>
      {children}
    </div>
  );
};

export default PopoverRoot;
